<script setup lang="ts">
import { WEB_APP_URL } from '~/constants/website'

const expeditions = [
  {
    icon_url: '/images/batch-2/instant-motor.png',
    title: 'Motor',
    description:
      'Motor ideal untuk paket dengan berat maksimum 40 kg. Pilihan ini cocok untuk pengiriman barang ringan dan dibutuhkan dalam waktu singkat.'
  },
  {
    icon_url: '/images/batch-2/instant-car.png',
    title: 'Mobil',
    description:
      'Mobil dapat menampung paket hingga 450 kg. Dengan kapasitas luas, barang berdimensi besar akan sampai dengan aman dan tepat waktu.'
  }
]
</script>

<template>
  <UiContainer class="flex flex-col gap-11 py-7 lg:py-12">
    <UiSectionTitle
      class="text-center"
      title="Jenis Kendaraan"
      description="Pengiriman instant menawarkan jenis kendaraan mobil dan motor sesuai berat paket yang kamu kirim,<br />memastikan kecepatan dan efisiensi dalam setiap pengiriman."
    />
    <div
      class="w-full lg:max-w-10/12 mx-auto flex gap-5 justify-center items-stretch flex-wrap"
    >
      <UiCardLink
        v-for="(expedition, index) in expeditions"
        :key="index"
        :title="expedition.title"
        :description="expedition.description"
        link-label="Kirim Paket"
        :to="$utm.utmUrl(WEB_APP_URL)"
        external
        :icon-url="expedition.icon_url"
      />
    </div>
  </UiContainer>
</template>
